import React, { useContext } from "react";
import { NotificationContext } from "../context/NotificationContext";

function TokenTable({ text, num }) {
  const { notify } = useContext(NotificationContext);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(num);
      notify.info("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy!", err);
      notify.error("Unable to copy to clipboard.");
    }
  };
  return (
    <div className="token-table">
      <div className="table-text">
        <h6>{text}</h6>
        <div style={{ cursor: "pointer" }} onClick={handleCopy}>
          <p>
            {num}
          </p>
        </div>
      </div>
    </div>
  );
}

export default TokenTable;
